import React from "react";
import {
  Table,
  Label,
  Segment,
  Button,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import { Grids, commonLabels } from "../../../../redux/constants/Values";

export const Alarms = (props) => {
  const {
    detailsPageButtonIsClicked,
    alarmDetailsdata,
    isFetchingAlarmsData,
  } = props;
  return (
    <>
      <Segment padded>
        <Label attached="top" size="big" className="bgBlue">
          {Grids.alarms}
          <Button
            primary
            onClick={detailsPageButtonIsClicked.bind(this, Grids.alarms)}
            floated="right"
          >
            {commonLabels.viewAll}
          </Button>
        </Label>
        <Table
          className="displayTable"
          singleLine
          compact
          striped
          sortable
          celled
          textAlign="center"
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Alarm Date</Table.HeaderCell>
              <Table.HeaderCell>Triggering Rule</Table.HeaderCell>
              <Table.HeaderCell>Alarm Severity</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {isFetchingAlarmsData ? (
            <Dimmer active inverted>
              <Loader size="mini">{commonLabels.fetching}</Loader>
            </Dimmer>
          ) : (
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 0
                    ? alarmDetailsdata[0].alarmDate
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 0
                    ? alarmDetailsdata[0].triggeringRule
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 0
                    ? alarmDetailsdata[0].alarmSeverity
                    : ""}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 1
                    ? alarmDetailsdata[1].alarmDate
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 1
                    ? alarmDetailsdata[1].triggeringRule
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 1
                    ? alarmDetailsdata[1].alarmSeverity
                    : ""}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 2
                    ? alarmDetailsdata[2].alarmDate
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 2
                    ? alarmDetailsdata[2].triggeringRule
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 2
                    ? alarmDetailsdata[2].alarmSeverity
                    : ""}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 3
                    ? alarmDetailsdata[3].alarmDate
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 3
                    ? alarmDetailsdata[3].triggeringRule
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 3
                    ? alarmDetailsdata[3].alarmSeverity
                    : ""}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 4
                    ? alarmDetailsdata[4].alarmDate
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 4
                    ? alarmDetailsdata[4].triggeringRule
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {alarmDetailsdata && alarmDetailsdata.length > 4
                    ? alarmDetailsdata[4].alarmSeverity
                    : ""}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          )}
        </Table>
      </Segment>
    </>
  );
};

export default Alarms;
